import {FaComments, FaFileInvoiceDollar} from "react-icons/fa";
import {IoLocationSharp} from "react-icons/io5";
import {MdAccountBox, MdFavorite} from "react-icons/md";
import {Roles} from "@configs/panel/roles/ProjectRole";
import PanelPaths from "@router/paths/panel";
import projectPermissions from "../roles/ProjectPermissions";

const customerPanelSideBar = [
    /*{
        id: "user_doors",
        title: "MyDoors",
        type: "item",
        icon: <MessageSquareIcon size={20}/>,
        navLink: PanelPaths.customer.customerDoors,
        roles: [Roles.customer],
        permissions: []
    },*/
    {
        id: "user_address",
        title: "MyAddress",
        type: "item",
        icon: <IoLocationSharp size={22}/>,
        navLink: PanelPaths.customer.addresses,
        roles: [Roles.customer],
        active:true,
        permissions: []
    },
    {
        id: "user_invoices",
        title: "Invoices",
        type: "item",
        icon: <FaFileInvoiceDollar size={22}/>,
        navLink: PanelPaths.customer.invoices,
        roles: [Roles.customer],
        active:true,
        permissions: [],
    },
    {
        id: "user_comments",
        title: "Comments",
        type: "item",
        icon: <FaComments size={22}/>,
        navLink: PanelPaths.comments,
        roles: [Roles.customer],
        active:true,
        permissions: [],
    },
    {
        id: "user_favorite",
        title: "Favorite",
        type: "item",
        icon: <MdFavorite size={22}/>,
        navLink: PanelPaths.customer.favorite,
        roles: [Roles.customer],
        active:true,
        permissions: [],
    },
    {
        id: "account",
        title: "account",
        type: "collapse",
        icon: <MdAccountBox size={22}/>,
        navLink: PanelPaths.userAccount,
        roles: [Roles.customer],
        active:true,
        permissions: [],
    },
];

export default customerPanelSideBar;
